export default "__VITE_ASSET__YdU_Mnpt__"